import React, { useState } from "react";
import WidgetName from "../WidgetName";
import { titleContainsText } from "../helpers";
import "./head-to-head-widget.scss";
import HeadCard from "./HeadCard";
import ErrorBoundary from "../ErrorBoundary";

/**
 * Root element for the "head-to-head" widget type.
 */
const HeadToHeadWidget = props => {
  const raceDisplay = props.widget.raceDisplay;
  const [filterText, setFilterText] = useState("");

  const offices = props.results
    .filter(titleContainsText(filterText))
    .map((office, index) => {
      // raceDisplay === "auto": collapse all cards but the first.
      const collapsed = raceDisplay === "collapse-all" || (raceDisplay === "auto" && index > 0);

      return (
        <ErrorBoundary key={index} message={process.env.REACT_APP_ERROR_MESSAGE}>
          <HeadCard office={office} options={props.widget} collapsed={collapsed} />
        </ErrorBoundary>
      );
    });

  return (
    <div className="headToHead">
      {props.widget.showSearchBar && (
        <input className="filter-input"
          type="text"
          placeholder="Filter"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)} />
      )}

      <WidgetName widget={props.widget} updated={props.updated} />

      {offices}
    </div>
  );
};

export default HeadToHeadWidget;
